import React, { useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";
import DBperAreaproblemiDB from "./AreaproblemiDBComponenti/DBperAreaproblemiDB";

function AreaproblemiDB({product,setProductFunction,utente,tradPermessa,setTradPermessa,setCharCount, charCount, listaNomiProdotto}) {

    

    /////// PROPS ///////////////

    //const utente = props.utente
    const {
        /* buttonClassesWhite,
        buttonClassesRed,
        buttonClassesOrange,
        buttonClassesGreen,
        inputClasses,
        inputClassesThird, */
        inputClassesConTasto/*,
         inputClassesConDueTasti,
        inputClassesConTreTasti,
        spazioTestoConTasto,
        classiTastoBlocco,
        classiTastoSblocco,
        classiTastoCopiaInAlto,
        classiTastoSbloccoVerde,
        tastoQuadratoVerde,
        tastoQuadratoGiallo,
        tastoQuadratoRosso,
        tastoQuadratoBianco,
        buttonClassesWhiteNoBorder */
    } = stilePulsanti

    /////// HOOKS ///////////////




    return (
        <div className='center'>
            <div className='cf'>
                {/* <h1>scegli prod o crea nuovo: [input show or create]</h1> */}
                <div className="fl w-100 w-100-ns">
                {product.codiceVS === "NO DATA" && 
                
                <div className="sfondoBiancoTema">
                        <DBperAreaproblemiDB
                            product={product}
                            setProductFunction={setProductFunction}
                            utente={utente}
                            tradPermessa={tradPermessa}
                            setTradPermessa={setTradPermessa}
                            charCount={charCount}
                            setCharCount={setCharCount}
                        />                        
                    </div>}
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    <div className="sfondoBiancoTema">
                    
                    {product.codiceVS !== "NO DATA" && 
                    
                    <ModificaProdottiNEW
                        prodotto={product}
                        setProductFunction={setProductFunction}
                        utente={utente}
                        listaNomiProdotto={listaNomiProdotto}
                        /* listaNomiProdotto={listaNomiProdotto} */
                        />}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AreaproblemiDB;